import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  isPublicPage = () => {
    const path = window.location.pathname;
    // Проверяем, является ли страница публичной (для сотрудников)
    return path.startsWith('/employee/');
  };

  render () {
    const showNavigation = !this.isPublicPage();

    return (
      <div>
        {showNavigation && <NavMenu />}
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
